export const PrismicConfig = {
    apiEndpoint : 'https://portal-in-touch.cdn.prismic.io/api/v2',
    apiAccessToken: 'MC5YRzV2enhVQUFLZWxGc3B3.77-977-977-9TnBE77-977-9be-_ve-_vT9Oa39nCCsr77-9HEEG77-977-9ZCLvv73vv73vv73vv70Q'
}

export const PrismicConfigMarketingPage = {
    apiEndpoint : 'https://intouchnetworks-marketing-site.cdn.prismic.io/api/v2',
    apiAccessToken: 'MC5XLVJSanhFQUFDVUFDdjlZ.77-9Re-_vUzvv73vv713diYxe--_ve-_ve-_ve-_vTvvv73vv73vv70e77-977-9Pw7vv73vv71xa--_ve-_ve-_vVw'
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/PrismicAPI.js